import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=24587985&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=ts&"
export * from "./main-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24587985",
  null
  
)

export default component.exports